import React, { memo } from 'react';
import S from './style/OlxLogoContainer';
import OlxLogo from './icons/OlxLogo';

function OlxLogoContainer({ homepageUrl }) {
  const navigateToHomePage = () => {
    window.location.assign(homepageUrl);
  };

  return (
    <S.Wrapper>
      <OlxLogo data-testid="olxLogo" onClick={navigateToHomePage} />
    </S.Wrapper>
  );
}

export default memo(OlxLogoContainer);
